import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import moment from 'moment';
import { LoyaltyExplainerModalState } from '@/components/modals/CmgLoyaltyExplainerModal/cmg-loyalty-explainer-modal';
import { CustomerProfile, MarketingChannel, MarketingContext, SubmitRetroCreditRequest } from '@/models';
import { EnrollmentOptions } from '@/services/loyalty/loyalty.service';
import { isAutoSubscribesToMarketingEmail } from '@/helpers/country';

@Component({
  name: 'CmgOrderConfirmationJoinLoyalty',
})
export default class CmgOrderConfirmationJoinLoyalty extends Vue {
  joiningLoyalty = false;

  get loyaltyMedallionImageUrl(): string {
    return this.$appStore.state.cms.images.logos.medallionRewardShout.default.replace('dev', 'int');
  }

  get customer(): CustomerProfile | null {
    return this.$appStore.state.customer.profile;
  }

  get legalCopy(): string {
    return this.$services.config.getLegalText().loggedInUnEnrolled;
  }

  get hasDeclinedLoyalty(): boolean {
    return this.$appStore.state.customer.loyalty.declined;
  }

  get headingText(): string {
    return this.joinedLoyaltyOnOrderConfirmationPage
      ? 'THANKS FOR JOINING. YOUR POINTS ARE ON THE WAY.'
      : 'LAST CHANCE TO EARN POINTS FOR THIS ORDER';
  }

  get joinedLoyaltyOnOrderConfirmationPage(): boolean {
    return this.$appStore.state.customer.loyalty.joinedLoyaltyOnOrderConfirmationPage;
  }

  async onClickJoinNow() {
    this.joiningLoyalty = true;

    try {
      const shouldSubscribeToMarketingEmail = isAutoSubscribesToMarketingEmail(this.customer?.country);
      const hasEmailMarketing = this.$services.customer.hasSubscription(MarketingChannel.Email, MarketingContext.Marketing);
      const enrollmentOptions: EnrollmentOptions = { customer: this.customer, pageTitle: document.title, shouldSubscribeToMarketingEmail };

      await this.$services.loyalty.enrollInLoyalty(enrollmentOptions);
      this.$services.ui.setLastSelectedElement('points-on-the-way');
      this.$services.ui.showOnboardingModal(this.$services.customer, this.customer ?? undefined);
      this.$services.customer.setJoinedLoyaltyOnOrderConfirmationPage(true);

      const order = this.$store.state.order.lastOrder.order.order;

      const retroCreditRequest: SubmitRetroCreditRequest = {
        restaurantId: order.restaurantId,
        checkNumber: this.$services.utils.generateRandomNumberString(5), // Need to send dummy 5 digit check number - ok because onlineOrderId is populated
        transactionDate: order.orderDateTimeLocal || moment().format(),
        transactionAmount: order.orderTotalAmount,
        onlineOrderId: order.orderId
      };
      
      this.$services.retroCredit.submit(retroCreditRequest);

      if (!shouldSubscribeToMarketingEmail && !hasEmailMarketing) {
        this.$services.ui.setModalVisibility('subscribeEmailMarketing', true);
      }
    } catch (e: any) {
      this.$services.logger.error('Something went wrong enrolling in loyalty', undefined, e);
    } finally {
      this.joiningLoyalty = false;
    }

  }

  onClickHowItWorks(event: any) {
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('loyaltyExplainer', true, {
      state: LoyaltyExplainerModalState.Explainer,
    });
    this.$services.ui.firstFocus();
  }

  declineLoyalty() {
    this.$services.loyalty.declineLoyalty();
  }
}
